import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import Swal from "sweetalert2";
import * as utils from "../../Utils/comman";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../reducers/userProfileSlice";
import {numberFormat} from "../../Utils/comman";
//import "../../assets/scss/styles/timeline.css";

function MarketingChallan(props) {
  const [marketingData, setMarketingData] = useState([]);

  const dispatch = useDispatch();
  const userProfile = useSelector((state) => state?.userProfile?.userProfile);


  useEffect(() => {
    if (!userProfile) {
      dispatch(fetchUserProfile());
    }
  }, [userProfile]);

  useEffect(() => {
    getMarketingChallanData();
  }, []);

  const handleBackClick = (e) => {
    const propdata = {
      mode: "list",
    };
    props.onChange(propdata);
  };

  const handleDownload = () => {
    utils
      .callAPI("get", `/sales/download_material_challan/${props?.rowData?.pi_response?.id}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          //window.open(res, "_blank");
          const a = document.createElement("a");
          a.href = res;
          a.target = "_blank"; // or "_self" depending on your preference
          a.rel = "noopener noreferrer";
          a.click();
        } else {
          //setPiData([]);
        }
      })
      .catch((err) => {
        // setPiData([]);
      });
  };

  const getMarketingChallanData = () => {
    console.log(props?.rowData)
    const orderId = props?.rowData?.orderdata && props?.rowData?.orderdata.id ? props?.rowData?.orderdata.id : props?.rowData?.id;
    utils
      .callAPI("get", `/sales/getOrdersMarketingList?id=${orderId}`)
      .then((res) => {
        if (typeof res !== "undefined") {
          setMarketingData(res);
        } else {
          setMarketingData([]);
        }
      })
      .catch((err) => {
        setMarketingData([]);
      });
  };

  const formatFactoryAddress = (locationdata) => {
    const factoryAddress = [];
    if(locationdata?.address) {
      factoryAddress.push(locationdata?.address);
    }

    if(locationdata?.city) {
      factoryAddress.push(locationdata?.city);
    }

    if(locationdata?.district) {
      factoryAddress.push(`Dist. : ${locationdata?.district}`);
    }

    if(locationdata?.pincode) {
      factoryAddress.push(locationdata?.pincode);
    }

    if(locationdata?.state) {
      factoryAddress.push(locationdata?.state);
    }

    factoryAddress.push('India.');

    return factoryAddress.join(', ');
  }

  const calculateItemPrice = (material) => {
    return parseFloat(material.qty) * parseFloat(material.price);
  }

  return (
    <div className="section-body">
      <RB.Card className="card ">
        <RB.Card.Header className="border-01">
          <h4>Marketing Challan</h4>
          <div className="card-header-action">
            <RB.Button className="btn btn-light me-2" onClick={handleDownload}>
              Download
            </RB.Button>
            <RB.Button className="btn btn-light" onClick={handleBackClick}>
              Back
            </RB.Button>
          </div>
        </RB.Card.Header>
        <RB.Card.Body className="p-21 p-md-31">

          <RB.Row>
            <RB.Col className={"border"}>
              <RB.Row>
                <RB.Col className={"text-center border-bottom py-2"}>
                  <h5 className={"mb-0"}>VURA BAU-CHEMIE LLP</h5>
                </RB.Col>
              </RB.Row>
              <section className={"challan-header w-100 py-2"}>
                <RB.Row>
                  <RB.Col className={"py-1"}>
                    <strong>Regd. Office:</strong> {marketingData?.reg_office}
                  </RB.Col>
                </RB.Row>
                <RB.Row>
                  <RB.Col className={"py-1"}>
                    <strong>Factory Address:</strong> {formatFactoryAddress(marketingData?.locationdata)}
                  </RB.Col>
                </RB.Row>
                <RB.Row>
                  <RB.Col className={"py-1 fw-bold"}>
                    GST : {marketingData?.locationdata?.gst_uni}
                  </RB.Col>
                </RB.Row>
                <RB.Row>
                  <RB.Col className={"py-1 fw-bold"}>
                    LLP NO : {marketingData?.locationdata?.llp_no}
                  </RB.Col>
                </RB.Row>
              </section>

              <RB.Row>
                <RB.Col className={"text-center border-top border-bottom py-2"}>
                  <strong>Delivery Challan</strong>
                </RB.Col>
              </RB.Row>

              <section>
                <RB.Row className={"border-bottom"}>
                  <RB.Col md={1} className={"text-center py-2"}>
                    <strong>To,</strong>
                  </RB.Col>
                  <RB.Col md={7} className={"border-end py-2"}>
                    <strong>{marketingData?.channel_partner_name}</strong> <br/>
                    {marketingData?.channel_name} <br/>
                    {marketingData?.company_city}
                  </RB.Col>
                  <RB.Col md={4}>
                    <RB.Row className={"border-bottom"}>
                      <RB.Col md={6} className={"border-end py-md-3"}><strong>Challan No:</strong></RB.Col>
                      <RB.Col md={6} className={"py-md-3"}>{marketingData?.challan_no}</RB.Col>
                    </RB.Row>
                    <RB.Row>
                      <RB.Col md={6} className={"border-end py-md-3"}><strong>Date:</strong></RB.Col>
                      <RB.Col md={6} className={"py-md-3"}>{moment(marketingData?.createdAt).format('DD-MM-YYYY')}</RB.Col>
                    </RB.Row>
                  </RB.Col>
                </RB.Row>
              </section>

              <section>
                <RB.Row>
                  <RB.Col md={8} className={"border-end d-flex align-items-center"}>
                    <div className={"w-100"}>
                    <RB.Row>
                      <RB.Col><strong>GST:</strong></RB.Col>
                    </RB.Row>
                    <RB.Row>
                      <RB.Col><strong>STATE CODE:</strong></RB.Col>
                    </RB.Row>
                    </div>
                  </RB.Col>
                  <RB.Col md={4}>
                    <RB.Row className={"border-bottom"}>
                      <RB.Col md={6} className={"border-end py-1"}><strong>INV NO:</strong></RB.Col>
                      <RB.Col md={6} className={"py-1"}>{marketingData?.invoice_no}</RB.Col>
                    </RB.Row>
                    <RB.Row className={"border-bottom"}>
                      <RB.Col md={6} className={"border-end py-1"}><strong>INV DATE:</strong></RB.Col>
                      <RB.Col md={6} className={"py-1"}>{moment(marketingData?.invoice_date).format('DD-MM-YYYY')}</RB.Col>
                    </RB.Row>
                    <RB.Row className={"border-bottom"}>
                      <RB.Col md={6} className={"border-end py-1"}><strong>SO NO :</strong></RB.Col>
                      <RB.Col md={6} className={"py-1"}>{marketingData?.order_id}</RB.Col>
                    </RB.Row>
                  </RB.Col>
                </RB.Row>
              </section>

              <section>
                <RB.Row>
                  <RB.Col className={"p-0"}>
                    <RB.Table
                        responsive
                        bordered
                        hover
                        striped
                        className="border mb-0"
                    >
                      <thead>
                      <tr>
                        <th className={"text-center"} style={{width: "10%"}}>SR No.</th>
                        <th className="text-center">Description of Item</th>
                        <th className="text-center" style={{width:"16.7%"}}>Qty</th>
                        <th className="text-center" style={{width:"16.7%"}}>Amount</th>
                      </tr>
                      </thead>
                      <tbody>
                      {marketingData?.material && marketingData?.material.map((material, i) => (
                      <tr key={i}>
                        <td className={"text-center"}>{i+1}</td>
                        <td>{material.material_item_name}</td>
                        <td className={"text-center"}>{material.qty}</td>
                        <td className={"text-end"}>{numberFormat(calculateItemPrice(material), 2)}</td>
                      </tr>
                      ))}

                      </tbody>
                      <tfoot>
                      <tr>
                        <td>&nbsp;</td>
                        <th>Total Qty.</th>
                        <th className={"text-center"}>{marketingData?.material_total_qty}</th>
                        <td className={"text-end"}></td>
                      </tr>
                      </tfoot>
                    </RB.Table>
                  </RB.Col>
                </RB.Row>
                <RB.Row>
                  <RB.Col md={8} className={"border-end border-bottom"}>
                    <RB.Row>
                      <RB.Col md={12} className={"pt-2 pb-1"}><strong>Firm's Bank Details:</strong></RB.Col>
                      <RB.Col md={12} className={"pb-1"}><strong>Firm Name:</strong> Vura Bau-Chemie LLP 0</RB.Col>
                      <RB.Col md={12} className={"pb-1"}><strong>Bank Name:</strong> ICICI Bank</RB.Col>
                      <RB.Col md={12} className={"pb-1"}><strong>Account No.:</strong> 062505001850 </RB.Col>
                      <RB.Col md={12} className={"pb-1"}><strong>Branch Name & IFSC Code:</strong> NEW CG ROAD & ICIC0000625</RB.Col>
                    </RB.Row>
                  </RB.Col>
                  <RB.Col md={4} className={"border-bottom"}>
                    <RB.Row>
                      <RB.Col md={6} className={"border-end text-end py-2"}><strong>TAXABLE VALUE</strong></RB.Col>
                      <RB.Col md={6} className={"text-end pe-4 border-bottom py-2"}>{numberFormat(marketingData?.material_total_taxable)}</RB.Col>
                    </RB.Row>
                    {marketingData?.material_cgst && (
                    <RB.Row>
                      <RB.Col md={6} className={"border-end text-end py-2"}><strong>CGST 9%</strong></RB.Col>
                      <RB.Col md={6} className={"text-end pe-4 border-bottom py-2"}>{numberFormat(marketingData?.material_cgst)}</RB.Col>
                    </RB.Row>
                    )}
                    {marketingData?.material_sgst && (
                    <RB.Row>
                      <RB.Col md={6} className={"border-end text-end py-2"}><strong>SGST 9%</strong></RB.Col>
                      <RB.Col md={6} className={"text-end pe-4 border-bottom py-2"}>{numberFormat(marketingData?.material_sgst)}</RB.Col>
                    </RB.Row>
                    )}
                    {marketingData?.material_igst && (
                    <RB.Row>
                      <RB.Col md={6} className={"border-end text-end py-2"}><strong>IGST 18%</strong></RB.Col>
                      <RB.Col md={6} className={"text-end pe-4 border-bottom py-2"}>{numberFormat(marketingData?.material_igst)}</RB.Col>
                    </RB.Row>
                    )}
                    <RB.Row>
                      <RB.Col md={6} className={"border-end text-end py-2"}><strong>NET PAYABLE</strong></RB.Col>
                      <RB.Col md={6} className={"text-end pe-4 py-2"}><strong>{numberFormat(marketingData?.material_total_net)}</strong></RB.Col>
                    </RB.Row>
                  </RB.Col>
                </RB.Row>
              </section>

              <section>
                <RB.Row>
                  <RB.Col md={8} className={"border-end py-2"}>
                    <strong>Remark:</strong>
                    <ul>
                      <li>Goods once sold will not be taken back</li>
                      <li>Subject to Ahmedabad Jurisdiction</li>
                      <li><h6>SAMPLE NOT FOR SALE</h6></li>
                    </ul>
                  </RB.Col>
                  <RB.Col md={4} className={"py-2 text-center"}>
                    For, VURA BAU-CHEMIE LLP
                    <br/><br/><br/><br/>
                    Authorized Signatory
                  </RB.Col>
                </RB.Row>
              </section>
            </RB.Col>
          </RB.Row>

        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default MarketingChallan;
